export default __webpack_public_path__ + "static/media/kd3.fec4ae55.JPG";